module.exports = __webpack_public_path__ + "img/no5.c3fe6f4a.jpg";